import { getCurrentUser } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const HeaderBar = styled.div`
  width: 100%;
  background-color: #333;
`;

const Header = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  li, a {
    display: block;
    padding: 14px 16px;
    color: white;
    text-align: center;
    text-decoration: none;
  }
`;

const HeaderItem = styled.li`
  display: inline;
  float: left;
`;

const HeaderItemRight = styled.li`
  display: inline;
  float: right;
`;

export const AppHeader = () => {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        // User authenticated
        setUser(user);
      })
      .catch(() => {
        // Auth error occurred
      });
  },[]);


  return (
    <HeaderBar>
      <Header>
        <HeaderItem>
          <Link to="/leagues">Leagues</Link>
        </HeaderItem>
        <HeaderItemRight>
          {
            user != null ?
              <div>
                <Link to="/coach">{user.username}</Link>
                <Link to="/logout">(Logout)</Link>
              </div>
              :
              <Link to="/login">Login</Link>
          }
        </HeaderItemRight>
      </Header>
    </HeaderBar>
  );
}